class TokenService {
  #TOKEN_KEY = 'access_token'
  #ACCESS_TOKEN_EXPIRES = 'access_token_expires'
  #SCRM_TOKEN_KEY = 'scrm_token'
  #SCRM_TOKEN_EXPIRES_KEY = 'scrm_token_expires'

  getToken() {
    return localStorage.getItem(this.#TOKEN_KEY)
  }

  saveToken(accessToken) {
    localStorage.setItem(this.#TOKEN_KEY, accessToken)
  }

  removeToken() {
    localStorage.removeItem(this.#TOKEN_KEY)
  }

  getAccessTokenExpires() {
    return localStorage.getItem(this.#ACCESS_TOKEN_EXPIRES)
  }

  saveAccessTokenExpires(refreshToken) {
    localStorage.setItem(this.#ACCESS_TOKEN_EXPIRES, refreshToken)
  }

  removeAccessTokenExpires() {
    localStorage.removeItem(this.#ACCESS_TOKEN_EXPIRES)
  }

  getScrmToken() {
    const expires = localStorage.getItem(this.#SCRM_TOKEN_EXPIRES_KEY)
    if (expires && Date.now() < Number(expires)) {
      return localStorage.getItem(this.#SCRM_TOKEN_KEY)
    }
    this.removeScrmToken()
    return null
  }

  saveScrmToken(token, expiresInSeconds) {
    localStorage.setItem(this.#SCRM_TOKEN_KEY, token)
    localStorage.setItem(this.#SCRM_TOKEN_EXPIRES_KEY, String(Date.now() + expiresInSeconds * 1000))
  }

  removeScrmToken() {
    localStorage.removeItem(this.#SCRM_TOKEN_KEY)
    localStorage.removeItem(this.#SCRM_TOKEN_EXPIRES_KEY)
  }
}

export const tokenService = new TokenService()
